import { gql } from "lib/apolloClient";

export const staffPermissionFragments = {
  staffPermissions: gql`
    fragment staffPermissions on Staff {
      permissions(curriculumProgramId: $permissionCurriculumId) {
        configuration {
          configurations {
            id
            configuration
            valueType
            value
          }
        }
      }
      __typename
    }
  `,
  teacherItemDetail: gql`
    fragment teacherItemDetail on Staff {
      id
      firstName
      middleName
      lastName
      profileImage
      email
      designation {
        id
      }
    }
  `,
};
